var React = require('react');

function Yt (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#565C65","d":"M30.573 3.435a3.923 3.923 0 0 0-2.76-2.778C25.378 0 15.613 0 15.613 0s-9.765 0-12.2.657a3.923 3.923 0 0 0-2.76 2.778C0 5.886 0 11 0 11s0 5.114.653 7.565a3.924 3.924 0 0 0 2.76 2.778c2.435.657 12.2.657 12.2.657s9.765 0 12.2-.657a3.924 3.924 0 0 0 2.76-2.778c.653-2.451.653-7.565.653-7.565s0-5.114-.653-7.565","key":0}),React.createElement("path",{"fill":"#FFFFFE","d":"M20.58 11l-8.16-4.643v9.286z","key":1})]));
}

Yt.defaultProps = {"width":"32","height":"22","viewBox":"0 0 32 22"};

module.exports = Yt;

Yt.default = Yt;
